import React from 'react'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import useUserInvitations from '../hooks/userInvitations/useUserInvitationsApi'
import GuestForm from '../components/guests/GuestForm'

export default function CreateGuestPage({ building }) {
  const history = useHistory()
  const location = useLocation()
  const { pathOverride, type, invitation } = location.state || {}

  const [_, methods] = useUserInvitations()

  return (
    <GuestForm
      building={building}
      handleCancel={() => history.push(pathOverride)}
      createUserInvitation={async (data) => {
        await methods.createUserInvitation(data)
        history.push(pathOverride)
      }}
      updateUserInvitation={async (id, data) => {
        await methods.updateUserInvitation(id, data)
        history.push(pathOverride)
      }}
      type={type}
      invitation={invitation}
    />
  )
}
